// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2FnES","paginationText":"styles_paginationText__2ab3g"};